import React from 'react';
import './index.css';
const NoAuth = () => {
    return (
        <div className='noAuth'>
            <div className='warning'>很抱歉，该课程仅对指定学员开放</div>
        </div>
    )
}

export default NoAuth